import { interceptErrorMessage } from '../../../shared/helpers/apiErrorsInterceptor';
import ajaxClient from '../../../utils/ajaxClient';

export const updateUserSettings = (data, onSuccess, onFailure) => {
  const url = 'Users/Current';

  return ajaxClient
    .patchRequest(url, null, data)
    .then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }
    })
    .catch((exception) => {
      if (exception) {
        if (onFailure) {
          onFailure(interceptErrorMessage(exception));
        }
      }
    });
};
